import React, { SyntheticEvent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import EyeIcon from 'assets/images/icons/eye.svg';

import { Pagination } from 'ui';
import Loader from 'ui/Loader';

import { PAGES } from 'utils/link';
import { QueryHelper } from 'utils/helpers';
import { QUERY_PARAMS } from 'utils/constants';

import { IRootStore } from 'store/Root.reducer';
import {
  getAdminUsersListRequest,
  setAdminUsersListPage,
} from 'store/Admin/UsersList/UsersList.action';
import { IGetAdminUsersItems } from 'store/Admin/UsersList/UsersList.type';

import { SortValues } from 'entities/common';

import styles from 'assets/scss/modules/AdminUsers/AdminUsers.module.scss';

// TODO loader
export const UsersTable: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data, isLoading } = useSelector(
    (store: IRootStore) => store.admin.usersList,
  );

  const handleChange = (page: number) => {
    dispatch(setAdminUsersListPage(page));
  };

  const handleRowClick = (user: IGetAdminUsersItems) => () => {
    navigate(PAGES.DASHBOARD.replace(':id', String(user.id)));
  };

  const handleView = (user: IGetAdminUsersItems) => (event: SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();

    navigate(PAGES.DASHBOARD.replace(':id', String(user.id)));
  };

  const handleEditStep =
    (user: IGetAdminUsersItems, step: 1 | 2) => (event: SyntheticEvent) => {
      event.preventDefault();
      event.stopPropagation();

      navigate(
        PAGES.USER_UPDATE.replace(':id', String(user.id)) +
          QueryHelper.getQueryString({
            [QUERY_PARAMS.STEP]: step,
          }),
      );
    };

  useEffect(() => {
    dispatch(
      getAdminUsersListRequest(
        QueryHelper.getQueryString({
          [QUERY_PARAMS.LIMIT]: data?.meta?.limit,
          [QUERY_PARAMS.SKIP]: (data?.meta?.page - 1) * data?.meta?.limit,
          [QUERY_PARAMS.SORT]: SortValues.ASC,
        }),
      ),
    );
  }, [data?.meta?.limit, data?.meta?.page, dispatch]);

  return (
    <section className={styles.card}>
      <Loader isLoading={isLoading} isGlobal />

      <div className={styles.tableWrapper}>
        <div className={styles.tableHeader}>
          <div className={styles.column}>Full name</div>
          <div className={styles.column}>Email</div>
          <div className={styles.column}>Object name</div>
          <div className={styles.columnActions}>Actions</div>
        </div>

        {data?.items?.map((user, index) => (
          <div
            onClick={handleRowClick(user)}
            key={index}
            className={styles.tableRow}
          >
            <div className={styles.column} data-label="Full name">
              {user.fullname}
            </div>

            <div className={styles.column} data-label="Email">
              <div className={styles.emailLink}>{user.email}</div>
            </div>

            <div className={styles.column} data-label="Object name">
              {user.objects?.map((item) => item.name)?.join(', ')}
            </div>

            <div className={styles.columnActions}>
              <button
                type="button"
                onClick={handleEditStep(user, 1)}
                className={styles.actionButton}
              >
                Edit personal info
              </button>

              <button
                type="button"
                onClick={handleEditStep(user, 2)}
                className={styles.actionButton}
              >
                Edit object info
              </button>

              <button
                type="button"
                onClick={handleView(user)}
                className={`${styles.iconButton} ${styles.iconEye}`}
                aria-label="View user"
              >
                <img src={EyeIcon} alt="" className={styles.icon} />
              </button>
            </div>
          </div>
        ))}
      </div>

      {data?.meta?.pages > 1 && (
        <Pagination
          pages={data?.meta?.pages}
          currentPage={data?.meta?.page}
          onChange={handleChange}
        />
      )}
    </section>
  );
};
